// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__TDWoF","container":"styles_container__2AhcG","title":"styles_title__IFiO2","wrapper":"styles_wrapper__2WhAz","answer":"styles_answer__2xrVN"};